import React from 'react'
import { useStyles } from './Styles'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import { FormattedMessage } from 'react-intl'
import Configuration from '../../../Services/Api/Configuration'

const TaxpayerSubscriptionWarning = ({ taxpayerSubscriptionsData }) => {
  const classes = useStyles()

  return (
    <Alert severity="warning" className={classes.TaxpayerSubscriptionAlert}>
      <AlertTitle><FormattedMessage id='TaxpayerSubscriptionWarning.title'/></AlertTitle>
      <FormattedMessage id='TaxpayerSubscriptionWarning.message' values={{
        subscriptionLink: <strong><a href={taxpayerSubscriptionsData?.service_subscription_url} target={'_blank'}
                                     rel="noreferrer nofollow">
          <FormattedMessage id='TaxpayerSubscriptionWarning.subscribeLink'/>
        </a></strong>,
        profileLink: <strong><a href={Configuration.PROFILING_URL} target={'_blank'}
                                rel="noreferrer nofollow">
          <FormattedMessage id='TaxpayerSubscriptionWarning.profileLink'/>
        </a></strong>
      }}/>
    </Alert>
  )
}

export default TaxpayerSubscriptionWarning
